//angular
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { CdkDragDrop, CdkDrag, moveItemInArray} from '@angular/cdk/drag-drop';
//app
import { panelPreferences } from '../../../../_shared/animations';
import { VisibleState } from 'src/app/app.data';
import { MetaService } from 'src/app/_core/services/meta.service';

@Component({
  selector: 'panel-preferences',
  templateUrl: './panel-preferences.component.html',
  animations: [panelPreferences]
})

export class PanelPreferencesComponent implements OnInit {
  status: boolean = false;
  statusPanel: string = 'isHidden';

  @Input()
  collectionOfGridColumn=[]

  @Input()
  title:string

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    public _meta: MetaService
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
  }

  closePanel() {
    if (this.statusPanel == VisibleState.isVisible && !this.status) {
      this.statusPanel = VisibleState.isHidden;
      this._meta.onCloseGridColumnsPreferences(this._meta.collectionOfMetaFields);
    } else {
      this.status = false;
    }
  }

  ngOnInit() {
  }

  onDropGridPreferenceOption(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.collectionOfGridColumn, event.previousIndex, event.currentIndex);
    this._meta.sortGridColumns(this.collectionOfGridColumn);
  }

  toggleGridPreferences() {
    this.status = !this.status;
    this.statusPanel = (this.statusPanel == VisibleState.isHidden ? VisibleState.isVisible : VisibleState.isHidden);
  }

}
